import { create } from 'zustand';

import { LocalStorage } from 'shared/utils';

import { OLD_PLATFORM_REDIRECT_DISMISSED_KEY } from '../consts';

interface OldPlatformRedirectModalState {
  /** Whether the modal is currently open. */
  isOpen: boolean;
  /** Old Platform URL to open once confirmed, or `null` when no redirect is pending. */
  pendingUrl: string | null;
  /** Opens the modal for the given Old Platform URL. */
  open: (url: string) => void;
  /** Confirms the redirect, optionally persisting the dismiss flag, then opens the pending URL in a new tab. */
  confirm: (dontShowAgain: boolean) => void;
  /** Closes the modal without redirecting. */
  cancel: VoidFunction;
}

export const useOldPlatformRedirectModalStore = create<OldPlatformRedirectModalState>()((set, get) => ({
  isOpen: false,
  pendingUrl: null,
  open: (url) => set({ isOpen: true, pendingUrl: url }),
  confirm: (dontShowAgain) => {
    const { pendingUrl } = get();

    if (dontShowAgain) {
      LocalStorage.set(OLD_PLATFORM_REDIRECT_DISMISSED_KEY, true);
    }

    if (pendingUrl) {
      window.open(pendingUrl, '_blank', 'noreferrer');
    }

    set({ isOpen: false, pendingUrl: null });
  },
  cancel: () => set({ isOpen: false, pendingUrl: null })
}));
